import { FormFieldWithOptions } from './formFieldWithOptions';

export class RadioButtonsField<TOptionKey> extends FormFieldWithOptions<
    TOptionKey,
    TOptionKey
> {}
